import React from "react";
import ReactDOM from "react-dom";
import App from "../src/components/App";
import reportWebVitals from "./reportWebVitals";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/custom-service-worker.js").then(
      (registration) => {
        // done
        // console.log(
        //   "Service Worker registered with scope:",
        //   registration.scope
        // );
      },
      (err) => {
        // error
        // console.error("Service Worker registration failed:", err);
      }
    );
  });
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
